import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SearchPage } from "@/features/search/SearchPage";

const search = z.object({
  q: z.string().optional(),
});

export const Route = createFileRoute("/_app/search/")({
  validateSearch: search,
  component: () => <SearchPage search={Route.useSearch()} />,
});
